import { render, staticRenderFns } from "./TicketsTapeManagement.vue?vue&type=template&id=29870802&"
import script from "./TicketsTapeManagement.vue?vue&type=script&lang=ts&"
export * from "./TicketsTapeManagement.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsTapeManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VContainer,VForm,VSnackbar,VStepper,VStepperContent,VStepperStep})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29870802')) {
      api.createRecord('29870802', component.options)
    } else {
      api.reload('29870802', component.options)
    }
    module.hot.accept("./TicketsTapeManagement.vue?vue&type=template&id=29870802&", function () {
      api.rerender('29870802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/TicketsTapeManagement.vue"
export default component.exports